module.exports = __webpack_public_path__ + "public/img/bim1.953e0ca0.png";